import ProfileRouter, { rootRouteName } from './types';

const Index = () =>
  import('../Index.vue' /* webpackChunkName: "notifications" */);

const NotificationsNotifications = () =>
  import('../views/notifications' /* webpackChunkName: "allnotifications" */);
const NotificationsUnread = () =>
  import('../views/unread' /* webpackChunkName: "unread" */);
const NotificationsSystemic = () =>
  import('../views/systemic' /* webpackChunkName: "systemic" */);

const toName = (value: string) => [rootRouteName, value].join('-');

export const notificationsRoutes = [
  {
    path: 'combined',
    component: NotificationsNotifications,
    name: toName('combined'),
    meta: { title: 'Уведомления' },
  },
  {
    path: 'unread',
    component: NotificationsUnread,
    name: toName('unread'),
    meta: { title: 'Непрочитанное' },
  },
  // {
  //   path: 'systemic',
  //   component: NotificationsSystemic,
  //   name: toName('systemic'),
  //   meta: { title: 'Системные' },
  // },
];

const createRoutes = ({ path, name, redirectTo404 }: ProfileRouter) => {
  const result = {
    path,
    name,
    component: Index,
    redirect: { name: toName('combined') },
    beforeEnter: redirectTo404('hasApiModuleNotifications'),
    meta: {
      inpath: 'profile-notifications'
    },
    children: notificationsRoutes,
  };

  return [result];
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/notification/router/index.ts